import { Link } from 'react-router-dom'
import './Temoignages.scss'
import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons'

const VIDEO_TEMOIGNAGES = [
  { youtubeId: 'jYfyLWqJx7A', title: 'Anaïs' },
  { youtubeId: 'P0J-PX-E1p0', title: 'Cécile' },
  { youtubeId: 'DD9tzZSHsGg', title: 'Nathalie' },
]

const MOBILE_VIDEO_MQ = '(max-width: 640px)'

const youtubeEmbedSrc = (youtubeId, { autoplay } = {}) =>
  autoplay
    ? `https://www.youtube.com/embed/${youtubeId}?playlist=${youtubeId}&autoplay=1&mute=1&loop=1`
    : `https://www.youtube.com/embed/${youtubeId}?rel=0`

function Temoignages() {
  const [showAll, setShowAll] = useState(false)
  const [videoIndex, setVideoIndex] = useState(0)
  const [isMobileVideoLayout, setIsMobileVideoLayout] = useState(() =>
    typeof window !== 'undefined'
      ? window.matchMedia(MOBILE_VIDEO_MQ).matches
      : false,
  )

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_VIDEO_MQ)
    const onChange = () => setIsMobileVideoLayout(mq.matches)
    onChange()
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [])

  const handleRedirect = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const data = [
    {
      img: 'image3.png',
      prenomVille: 'Kathleen',
      date: 'Juin 2023',
      temoignage:
        "Cette exploration de mon fonctionnement m'a apporté une meilleure connaissance de soi dans un moment de prendre du temps pour soi. Une explication sur ma bizarrerie de l'enfance. J'ai moins de jugement sur moi aujourd'hui mais je me dis que enfant savoir cela m'aurait permis de mieux me comprendre et de me pardonner mon comportement au lieu de le juger si mal. Je me serais sentie comprise. Du coup, j'ai beaucoup d'indulgence pour l'enfant que j'étais et je regarde d'un œil différent celle d'aujourd'hui. \n J'ai apprécié ta bonté, ta gentillesse. Tu es adorable et tu as l'écoute alors on te fait confiance facilement. \n\n J'ai vraiment trouvé rigolo les questions. \n\n Et de prendre du temps pour moi ce que j'ai du mal a faire. D'ailleurs depuis toi et le test en juin. Je me suis inscrite à des cours à l'université pour moi, pour mon plaisir… je suis séparée de mon conjoint ( j'ai retrouvé en sérénité)… j'envisage même de reprendre la course sans avoir saisi encore l'opportunité de me lancer. \n\n Je pense que certaines choses qu'on s'est dites on fait des liens ou des déclics intéressants.",
    },
    {
      img: 'image2.png',
      prenomVille: 'Jérôme',
      date: 'Septembre 2023',
      temoignage:
        "Cette exploration m'a permis de confirmer que mon profil avait bien des spécificités neuro atypiques. Ce qui me permet de mieux comprendre mon fonctionnement et du coup lâcher prise sur certaines choses sur lesquelles parfois je pouvais un peu m'acharner \n\n J'ai apprécié l'engagement dont tu as fait preuve et la restitution correcte de mon interview. Le partage des situations avec des réactions un peu similaires (on se sent toujours moins seul avec des personnes qui fonctionnent \"un peu comme nous`\" d'ailleurs je me demande quel est le pourcentage de multi potentiel dans la population. ?",
    },
    {
      img: 'image4.png',
      prenomVille: 'Sophie',
      date: 'Septembre 2023',
      temoignage:
        "Cette exploration m'a apporté : \n- des confirmations, validations de traits de caractère que je savais ou qu'on m'avait déjà évoqués \n- des nouveaux concepts : des mots que je ne connaissais pas \n- des échanges enrichissants \n- des liens entre la CNV et d'autres approches  \n- de la confiance : je ne suis pas une extraterrestre  \n- un temps pour moi \n\n J'ai apprécié \n - La mise en lien entre les réponses et les différents facettes de la haute sensibilité. \n - Les partages d'expérience \n - Les explications des différents concepts  \n - le fait de ne pas étiqueter mais de donner de la compréhension sur un mécanisme de réflexion, sur un fonctionnement différent ",
    },
    {
      img: 'image1.png',
      prenomVille: 'Clémentine',
      date: 'Avril 2024',
      temoignage:
        "Sache que ton accompagnement m'apporte également beaucoup. \n J'adore ce combo coaching / accompagnement hypersensibilité avec l'hypnose, \n qui me permet de conscientiser mes propres ressources, de les mobiliser, de me poser les bonnes questions et retrouver beaucoup de clarté et de confiance. \n Ces séances m'aident à libérer mes émotions et me boostent en énergie ! \n\n\n Je te remercie pour ton regard si bienveillant, ton écoute active et sans jugement et tous tes éclairages si judicieux. \n Je me suis tout de suite sentie en confiance et tu as su trouver le format idéal, qui me permet à la fois de me déposer et me libérer tout en me poussant vers l'action ! \n Depuis qu'on a recommencé nos séances, le fait de poser mes objectifs avec toi me donne envie d'avancer, de me surpasser. \n C'est comme si j'y croyais davantage et je me sens de plus en plus capable d'y arriver.\n Comme si je prenais davantage conscience de mes forces et de ma valeur. \n Cela m'apporte également beaucoup de douceur envers moi-même, \n et me permet de savourer chaque petite goutte d'eau de mon océan avec davantage de fierté et de reconnaissance. \n\n\n Nulle doute que tu es faite pour l'accompagnement ! \n Je te souhaite le meilleur dans ce projet de cœur, qui te permettra de mettre en lumière tous les trésors que tu as en toi. ✨\n Ne doute pas de ta réussite, \n car ce projet n'est autre que la continuité de toi-même et de tes talents naturels.",
    },
    {
      img: 'image6.png',
      prenomVille: 'Anna 37 ans, Orthophoniste',
      date: 'Juillet 2024',
      temoignage:
        "J'ai fait le test de douance avec Delphine. J'ai aimé l'exercice d'introspection que cela demande et ça m'a déjà appris sur moi d'entendre mes réponses. J'ai aimé le temps d'écoute que Delphine m'a accordé, sa patience, sa bienveillance. Elle a pris le temps pour m'expliquer en détail les résultats. J'étais quelque peu sceptique mais après son retour j'ai pu analyser mon comportement au vu des connaissances que j'avais accumulées grâce à elle et j'ai pu prendre conscience de mon fonctionnement à travers mon comportement. Elle m'a permis de diriger mon chemin d'évolution personnelle vers l'acceptation de qui je suis, de comment je fonctionne sans me juger. Elle m'a permis de donner du sens à ce que je vivais là où parfois je ne me comprends pas. Ça m'a ouvert des voies que je ne soupçonnais pas. \n\n Je recommande à tous de faire ce test et d'être suivi par Delphine pour se sentir légitime d'être pleinement soi. C'est un chemin semé d'embuches mais Delphine est là pour nous tenir la main, nous éclairer, nous pousser à voir notre lumière, ce qui nous rend unique, ce que l'on apporte au monde. Et ceux malgré nos pensées limitantes et nos jugements d'intérieurs. Ça permet de travailler sur un meilleur ancrage en soi, plus de bienveillance pour soi. De le faire ressentir aux autres et de contribuer peut-être à leur bien être en étant soi-même plus serein.",
    },
    {
      img: 'image7.png',
      prenomVille: "Cécile Avocate d'affaires",
      date: 'Juillet 2024',
      temoignage:
        'Merci beaucoup Delphine pour les prises de conscience que tu m’as permis de faire au cours de cette séance ✨ j’en ressors en mesurant encore davantage l’importance de prendre du recul sur mes besoins avant de m’engager trop rapidement 🙏 \n\n Tu m’as accordé une écoute bienveillante & rassurante et a su me poser les bonnes questions pour me faire cheminer vers une meilleure connaissance de moi💗 \n\n Je pense sincèrement que cela va m’apporter de belles choses. \n\n Merci encore. Cécile',
    },
    {
      img: 'image8.png',
      prenomVille: '',
      date: 'Octobre 2024',
      temoignage:
        "Je m'appelle Jérôme, j'ai 50 ans et je suis coordinateur logistique en pleine transition professionnelle. J'ai fait appel à Delphine pour un accompagnement en coaching, et dès le début, j'ai été impressionné par la qualité de ses services. Elle s'est montrée extrêmement à l'écoute, bienveillante et humble, ce qui a rendu nos échanges très fluides. \n\n Avant le coaching, je manquais d'organisation et j'avais du mal à comprendre certains aspects liés à mon hypersensibilité, ce qui affectait ma prise de décisions, tant sur le plan personnel que professionnel. Cette situation me laissait avec un sentiment de lassitude et une impression de stagnation. \n\n Grâce au coaching, j'ai pu clarifier ma situation, mieux comprendre mes fonctionnements internes et retrouver de la clarté dans mes objectifs. Je me sens maintenant plus apaisé, plus serein et confiant dans ma capacité à avancer. J'ai décidé de continuer à agir pas à pas pour surmonter cette période de transition. \n\n Ce que j'ai particulièrement apprécié chez Delphine, c'est son approche humaine, sa capacité à écouter et sa bienveillance constante. Je la recommande sans hésiter à toute personne cherchant à retrouver de la clarté et à avancer dans sa vie.",
    },
    {
      img: 'Image12.png',
      prenomVille: 'Sabine',
      date: '',
      temoignage:
        "Coach moi-même, je savais combien est aidant un accompagnement bienveillant, qui permet de réfléchir tout haut et d'avancer. J'ai choisi de me tourner vers Delphine, spécialiste de l'accompagnement des neuroatypiques, alors qu'il me fallait faire face à une peur qui me paralysait. Avec douceur, Delphine m'a accompagnée et m'a permis de comprendre ce qui se jouait pour moi, ce que je voulais lâcher et ce que je pouvais accepter, et de prendre conscience de mes ressources. Je recommande Delphine qui, avec la PNL et sa connaissance des neuropatypies, a plus d'une corde à son arc et a su créer un authentique climat de confiance !",
    },
    {
      img: 'Image13.png',
      prenomVille: 'Amor',
      date: '',
      temoignage:
        'L’exploration de la douance avec l’accompagnement de Delpfine a été d’une aide précieuse dans mon cheminement personnel vers une meilleure connaissance de moi-même. C’est extrêmement libérateur de découvrir les clés, les raisons et les motivations profondes qui nous animent. \n\n Bien sûr, c’est un chemin que l’on peut tenter seul, mais il n’aura jamais la même puissance que lorsqu’il est guidé. J’en suis convaincue. Je travaille sur moi depuis longtemps, mais je n’étais jamais allée aussi loin, aussi profondément. Même en essayant de reproduire l’analyse seule, je n’y suis pas parvenue. \n\n Cela demande du courage, je ne le nie pas, pour se regarder avec autant de lucidité. Dans un monde où tout va vite, où tout se consomme et se produit à un rythme effréné, il reste peu de place pour prendre le temps. Et c’est justement là que réside la magie de Delpfine : elle sait créer un espace de sécurité qui permet d’entrer en soi, pas à pas, avec une infinie tendresse. \n\n Je ne peux que vous recommander cette exploration de la douance, et tout particulièrement avec Delpfine à vos côtés. Merci beaucoup Delpfine',
    },
    {
      img: 'Image14.png',
      prenomVille: 'Cécile',
      date: '',
      temoignage:
        'J’ai 53 ans et je travaille en tant que Conseillère à l’emploi.\n\nJe n’ai pas hésité à devenir cliente du fait que je savais ce qu’était un coaching. Le tout était d’avoir le bon interlocuteur qui me donne l’impression de m’écouter et de me comprendre sans jugement. La confiance est venue quasi immédiatement du fait que Delpfine a vraiment pris le temps pour identifier les objectifs et les indicateurs.\n\nPour moi, cette expérience est très positive sur le fond et la forme, à la fois souple et cadrée. Je n’avais pas une vision claire de ce qui est « prendre soin de soi », j’étais frustrée de ne pas être à la hauteur de mes attentes, de ma vision et de mes désirs.\n\nAujourd’hui, au niveau professionnel, Je ressens un apaisement et une certaine sérénité. Je dois encore travailler sur le fait que cela est et restera qu’un sponsor de vie. C’est mon ego qui ne sera jamais pleinement satisfait par ma vie professionnelle. En fait, mon travail est de parvenir à « prendre du recul » en lien avec la notion de « l’acceptation ». C’est aussi de valoriser mon parcours.\n\nAu niveau personnel, je ressens plus de confiance et je suis plus à l’écoute de mes émotions. Cela va avec le fait d’essayer d’accepter le monde tel qu’il est. C’est à moi, tout en évitant de se couper du monde, de créer ma bulle de satisfaction au sens stricte du terme. C’est aussi à moi de m’apporter plus de joie et de plaisir dans toutes les petites choses de la vie quotidienne et en ressentir de la gratitude.\n\nCe coaching m’a apporté une réflexion sur mes comportements et mes attitudes. Aujourd’hui, je me pose plus souvent la question : « Comment je peux faire, dire, … pour que cela aille dans ce qui a du sens et de la valeur pour moi ? ». C’est cela « prendre soin de soi ».\n\n•\tModifier des points de vue, des croyances, des attitudes\n•\tComprendre mon côté social/asociale\n•\tPoursuivre mon travail sur le « prendre soin de soi » et la « prise de recul ».\n•\tUne foi plus importante envers moi-même.\n\nAujourd’hui, je ressens de la gratitude d’avoir rencontré une personne comme Delpfine. Ensuite, je me sens toujours « bouillonnante » dans ma tête mais plus sereine parce que je sais que cela fait partie de mon fonctionnement « normal ». Enfin, même si je me sens toujours contrariée par ce monde, je me sens plus armée sans pour autant partir en guerre. Le fameux « lâcher prise ».\n\nSuite à ce coaching, j’ai décidé\n\n•\tDe prendre en compte mes intuitions, mes aspirations, mes envies ;\n•\tDe ne plus procrastiner ;\n•\tDe reprendre de l’énergie pour et avec ma santé ;\n•\tDe penser bisounours non-naïf, plus clairement actionner la bienveillance avec lucidité ;\n•\tDe prendre soin de moi.\n\nDelpfine est une personne vraiment à\u00A0\u00A0l’écoute, capable d’analyser/synthétiser et de feed-back pertinents, tout cela sans jugement de sa part.\u00A0\u00A0En somme une professionnelle. Une vraie personne dotée des capacités et de valeurs humaines qui font croire que le monde ne part pas complètement dans une spirale infernale négative. \n\n Je la recommanderai les yeux fermés ! je suis ravie d’avoir fait ce travail.',
    },
  ]

  const renderTemoignage = (tem, index) => (
    <div className="temoignage glass" key={index}>
      {tem.img && (
        <img
          className="illustration_2"
          src={require(`../../assets/images/temoignage/${tem.img}`).default}
          alt={`temoignage de ${tem.prenomVille}`}
          width={100}
          height={100}
        />
      )}

      <div className="content">
        <p
          dangerouslySetInnerHTML={{
            __html: tem.temoignage.replace(/\n/g, '<br />'),
          }}
        />
        <div>{tem.prenomVille && <div>{tem.prenomVille}</div>}</div>
      </div>
    </div>
  )

  const displayedData = showAll
    ? [...data].reverse()
    : [...data].reverse().slice(0, 3)
  const videoCount = VIDEO_TEMOIGNAGES.length
  const currentVideo = VIDEO_TEMOIGNAGES[videoIndex]
  const prevVideoIndex = (videoIndex - 1 + videoCount) % videoCount
  const nextVideoIndex = (videoIndex + 1) % videoCount
  const prevVideo = VIDEO_TEMOIGNAGES[prevVideoIndex]
  const nextVideo = VIDEO_TEMOIGNAGES[nextVideoIndex]
  const goVideoPrev = () =>
    setVideoIndex((i) => (i - 1 + videoCount) % videoCount)
  const goVideoNext = () => setVideoIndex((i) => (i + 1) % videoCount)
  const youtubeThumb = (id) =>
    `https://img.youtube.com/vi/${id}/hqdefault.jpg`

  return (
    <section className="sub_container temoignage">
      <div className="text-align-center">
        <h2>Témoignage de personnes que j'ai accompagné</h2>
      </div>
      <div className="text-align-center">
        <p className="sub_text">
          (Avis Google, extraits d'e-mails, de SMS et de messages sur mes
          réseaux sociaux de personnes que j'ai accompagnées)
        </p>
      </div>
      <div className="temoignage_videos">
        <h3 className="temoignage_videos_title text-align-center">
          Témoignages en vidéo
        </h3>
        {isMobileVideoLayout ? (
          <div
            className="temoignage_video_stack"
            role="region"
            aria-label="Témoignages vidéo"
          >
            {VIDEO_TEMOIGNAGES.map((v) => (
              <div className="temoignage_video_stack_item" key={v.youtubeId}>
                <div className="temoignage_video_frame_wrap">
                  <iframe
                    title={`Témoignage vidéo — ${v.title}`}
                    src={youtubeEmbedSrc(v.youtubeId)}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                    allowFullScreen
                  />
                </div>
                <p className="temoignage_video_caption text-align-center">
                  {v.title}
                </p>
              </div>
            ))}
          </div>
        ) : (
          <>
            <div
              className="temoignage_video_carousel"
              role="region"
              aria-roledescription="carrousel"
              aria-label="Témoignages vidéo"
            >
              <button
                type="button"
                className="temoignage_video_nav temoignage_video_nav_prev"
                onClick={goVideoPrev}
                aria-label="Vidéo précédente"
              >
                <FontAwesomeIcon icon={faChevronLeft} />
              </button>
              <div className="temoignage_video_peeks">
                {videoCount > 1 && (
                  <button
                    type="button"
                    className="temoignage_video_peek temoignage_video_peek_side"
                    onClick={() => setVideoIndex(prevVideoIndex)}
                    aria-label={`Voir le témoignage de ${prevVideo.title}`}
                  >
                    <span className="temoignage_video_peek_media">
                      <img
                        src={youtubeThumb(prevVideo.youtubeId)}
                        alt=""
                        loading="lazy"
                        width={320}
                        height={180}
                      />
                    </span>
                    <span className="temoignage_video_peek_caption">
                      {prevVideo.title}
                    </span>
                  </button>
                )}
                <div className="temoignage_video_slide">
                  <div className="temoignage_video_frame_wrap">
                    <iframe
                      key={currentVideo.youtubeId}
                      title={`Témoignage vidéo — ${currentVideo.title}`}
                      src={youtubeEmbedSrc(currentVideo.youtubeId, {
                        autoplay: true,
                      })}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                      allowFullScreen
                    />
                  </div>
                  <p
                    className="temoignage_video_caption text-align-center"
                    aria-live="polite"
                  >
                    {currentVideo.title}
                  </p>
                </div>
                {videoCount > 1 && (
                  <button
                    type="button"
                    className="temoignage_video_peek temoignage_video_peek_side"
                    onClick={() => setVideoIndex(nextVideoIndex)}
                    aria-label={`Voir le témoignage de ${nextVideo.title}`}
                  >
                    <span className="temoignage_video_peek_media">
                      <img
                        src={youtubeThumb(nextVideo.youtubeId)}
                        alt=""
                        loading="lazy"
                        width={320}
                        height={180}
                      />
                    </span>
                    <span className="temoignage_video_peek_caption">
                      {nextVideo.title}
                    </span>
                  </button>
                )}
              </div>
              <button
                type="button"
                className="temoignage_video_nav temoignage_video_nav_next"
                onClick={goVideoNext}
                aria-label="Vidéo suivante"
              >
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </div>
            <div
              className="temoignage_video_dots"
              role="tablist"
              aria-label="Choisir une vidéo"
            >
              {VIDEO_TEMOIGNAGES.map((v, i) => (
                <button
                  key={v.youtubeId}
                  type="button"
                  role="tab"
                  aria-selected={i === videoIndex}
                  aria-label={`Voir le témoignage de ${v.title}`}
                  className={`temoignage_video_dot${i === videoIndex ? ' is-active' : ''}`}
                  onClick={() => setVideoIndex(i)}
                />
              ))}
            </div>
          </>
        )}
      </div>
      <div className="temoignage_container">
        {displayedData.map(renderTemoignage)}
      </div>
      {!showAll && (
        <a className="btn_secondary" onClick={() => setShowAll(true)}>
          Voir plus de témoignages
        </a>
      )}
      <Link to="/explore" className="btn_rervervation" onClick={handleRedirect}>
        VOIR LES OFFRES
      </Link>
    </section>
  )
}

export default Temoignages
